module.exports = __webpack_public_path__ + "static/media/c.ba677a4b.jpg";